<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" :disabled-apply="!disabled_apply" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-form
      ref="form"
      v-model="disabled_apply"
      lazy-validation
    >
      <v-text-field
          v-model="visitor.last_name"
          label="Фамилия посетителя"
          outlined
          class="mt-4"
          :rules="[rules.name]"
          :error="hasError('last_name')"
          :error-messages="getError('last_name')"
      >
        <template v-slot:label>
          Фамилия посетителя <strong class="red--text">*</strong>
        </template>
      </v-text-field>
      <v-text-field
          v-model="visitor.first_name"
          label="Имя посетителя"
          outlined
          :rules="[rules.name]"
          :error="hasError('first_name')"
          :error-messages="getError('first_name')"
      >
        <template v-slot:label>
          Имя посетителя <strong class="red--text">*</strong>
        </template>
      </v-text-field>
      <v-text-field
          v-model="visitor.middle_name"
          label="Отчество посетителя"
          outlined
          :error="hasError('middle_name')"
          :error-messages="getError('middle_name')"
      >
        <template v-slot:label>
          Отчество посетителя
        </template>
      </v-text-field>
    </v-form>
    <loading-autocomplete
        ref="organization-selector"
        v-if="!new_organization && !private_person"
        class="mb-n4"
        placeholder="Введите название и выберете из предложенных вариантов"
        label="Организация"
        outlined
        required
        v-model="visitor.organization"
        search-parameter="search"
        :url="organizations_selector"
        :error="hasError('organization')"
        :error-messages="getError('organization')"
        :item-text="getText"
        :load-fios="false"
        return-object
        :menu-props="{ maxWidth: 575, maxHeight: 150 }"
    >
      <template v-slot:no-data>
        <div>
          Для поиска начните набирать название, <br> и подождите 1 секунду, либо нажмите Enter
        </div>
      </template>
      <template v-slot:prepend-item>
        <v-btn
            block
            elevation="0"
            text
            @click="addNewOrganization"
        >
          <v-icon>add</v-icon>
          Добавить новую организацию
        </v-btn>
      </template>
    </loading-autocomplete>
    <!-- Блок добавления новой организации -->
    <v-card
        v-if="new_organization && !private_person"
        class="pa-4 mb-2"
        elevation="0"
        color="grey lighten-3"
    >
      <v-card-title class="text-body-1 text-sm-h6 px-0 pt-0 pb-2 text-left">
        Добавление новой организации:
      </v-card-title>
      <v-row no-gutters class="pa-0">
        <v-col cols="11" class="pr-md-1">
          <v-text-field
              ref="new-organization-full-name"
              class="pa-0 mt-2"
              outlined
              v-model="visitor.organization.full_name"
              label="Полное наименование организации"
              :error="hasError('organization.full_name')"
              :error-messages="getError('organization.full_name')"
          ></v-text-field>
        </v-col>
        <v-col cols="1" class="pl-md-2 pt-4">
          <v-btn
              fab
              icon
              small
              color="primary"
              @click="removeNewOrganization"
          >
            <v-icon>reply</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-text-field
              class="pa-0"
              outlined
              v-model="visitor.organization.short_name"
              label="Краткое наименование организации"
              :error="hasError('organization.short_name')"
              :error-messages="getError('organization.short_name')"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              class="pa-0"
              outlined
              v-model="visitor.organization.inn"
              label="ИНН организации"
              maxlength="12"
              :error="hasError('organization.inn')"
              :error-messages="getError('organization.inn')"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              class="pa-0"
              outlined
              v-model="visitor.organization.legal_address"
              label="Адрес организации"
              :error="hasError('organization.legal_address')"
              :error-messages="getError('organization.legal_address')"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-row no-gutters>
      <v-col cols="12" md="6" class="mt-n1">
        <v-checkbox
            v-if="!new_organization"
            @click="privatePerson"
            label="Частное лицо"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" :md="new_organization ? 12 : 6" class="mt-n1 mt-md-n3">
        <v-checkbox
            v-model="visitor.is_foreigner"
            label="Является иностранным гражданином"
            :error="hasError('is_foreigner')"
            :error-messages="getError('is_foreigner')"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row no-gutters class="text-left mb-n2">
      <v-col cols="12" class="text--secondary">Ограничения прохода:</v-col>
    </v-row>
    <v-radio-group
        v-model="visitor.is_in_blacklist"
        :error="hasError('is_in_blacklist')"
        :error-messages="getError('is_in_blacklist')"
    >
      <v-radio
          label="Без ограничений"
          color="grey"
          :value="false"
      ></v-radio>
      <v-radio
          label="Серый список"
          color="yellow"
          :value="null"
      ></v-radio>
      <v-radio
          label="Черный список"
          color="red"
          :value="true"
      ></v-radio>
    </v-radio-group>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import selectors from "@/urls/selectors";
import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete";

export default {
  name: "VisitorsEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    visitorData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog,
    LoadingAutocomplete
  },
  data() {
    return {
      save_loading: false,
      disabled_apply: true,
      visitor_default: {
        last_name: "",
        first_name: "",
        organization: undefined,
        is_foreigner: false,
        is_in_blacklist: false
      },
      visitor: undefined,
      new_organization: false,
      private_person: false,
      specialError: [],
      rules: {
        name: value => {
          const pattern = /^[а-яёА-ЯЁ]+(?:[- ][а-яёА-ЯЁ]+)*$/
          return pattern.test(value) || "Некорректный ввод"
        }
      }
    }
  },
  watch: {
    visitor: {
      handler: function() {
        this.errors = {
          fields: {},
          non: []
        }
      },
      deep: true
    }
  },
  computed: {
    form_title () {
      return this.edit === false ? "Добавить посетителя" : "Редактировать посетителя"
    },
    organizations_selector(){
      return selectors.SELECTORS.VISITORS.ORGANIZATIONS()
    }
  },
  methods: {
    ...mapActions({
      createVisitors: "admin/createVisitors",
      changeVisitors: "admin/changeVisitors",
      loadOrganizationsSelector: "selectors/loadOrganizationsSelector",
      loadVisitorDetail: "admin/loadVisitorsDetail"
    }),
    getText(value){
      if(value !== undefined)
        return `${value.inn}(${value.short_name})`
      else
        return ""
    },
    addNewOrganization() {
      this.visitor.organization = {}
      this.new_organization = true
      this.$nextTick(() => {
        this.$refs["new-organization-full-name"].focus();
        this.$refs["new-organization-full-name"].inputMode;
      })
    },
    removeNewOrganization() {
      this.visitor.organization = undefined
      this.new_organization = false
      this.$nextTick(() => {
        this.$refs["organization-selector"].focus();
        this.$refs["organization-selector"].isMenuActive = true;
      })
    },
    privatePerson() {
      if (!this.private_person) {
        this.private_person = true
        this.visitor.organization = {
          full_name: "ЧАСТНОЕ ЛИЦО",
          inn: "0000000000",
          legal_address: "ЧАСТНОЕ ЛИЦО",
          short_name: "ЧАСТНОЕ ЛИЦО",
          dadata: false,
          id: 1
        }
      } else {
        this.visitor.organization = undefined
        this.private_person = false
        this.$nextTick(() => {
          this.$refs["organization-selector"].focus();
          this.$refs["organization-selector"].isMenuActive = true;
        })
      }
    },
    close(){
      this.$emit("close", false)
    },
    loadVisitorsData(){
      if(this.visitorData === undefined){
        this.visitor = this.visitor_default
      }
      else{
        this.visitor = JSON.parse(JSON.stringify(this.visitorData))
        let url=undefined
        this.loadVisitorDetail({
          url: url,
          id: this.visitor.id,
          finalizer: (val) => {
            this.visitor = val
            this.new_organization = true
          }
        })
      }
    },
    save(){
      this.save_loading = true
      if (this.edit) {
        this.changeVisitors({
          data: this.visitor,
          finalizer: (val) => {
            this.$emit("close", this.visitor)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }else {
        this.createVisitors({
          data: this.visitor,
          finalizer: (val) => {
            this.$emit("close", this.visitor)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    }
  },
  created() {
    this.loadVisitorsData()
  }
}
</script>

<style scoped>

</style>
